function parseJSON(response) {
    if (204 === response.status || 205 === response.status) return null;
    return response.json();
}
function isNetworkErrorMessage(message) {
    return [
        'Failed to fetch',
        'NetworkError when attempting to fetch resource.',
        'Network request failed',
        'The Internet connection appears to be offline.'
    ].includes(message);
}
function isOnline() {
    return new Promise((resolve)=>{
        var _navigator;
        if ((null === (_navigator = navigator) || void 0 === _navigator ? void 0 : _navigator.onLine) === false) resolve(false);
        else {
            const ping = fetch('/health', {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
            const timeout = new Promise((_, reject)=>{
                setTimeout(()=>reject(new Error('timeout')), 3000);
            });
            Promise.race([
                ping,
                timeout
            ]).then(()=>resolve(true)).catch(()=>resolve(false));
        }
    });
}
function logError(error) {
    if ('SyntaxError' === error.name) throw new Error("Can't parse server response");
    if ('TypeError' === error.name && isNetworkErrorMessage(error.message)) throw new Error("Can't reach server. Please try again later");
    throw error;
}
function logErrorWithOnlineCheck(error) {
    if ('SyntaxError' === error.name) throw new Error("Can't parse server response");
    if ('TypeError' === error.name && isNetworkErrorMessage(error.message)) return isOnline().then((online)=>{
        if (online) throw new Error("Can't reach server. Please try again later");
        throw new Error('No Internet connection');
    });
    throw error;
}
function request(url, options = {}, responseInterceptor = parseJSON, errorInterceptor = logError) {
    return fetch(url, options).then((response)=>responseInterceptor(response, options.method)).catch(errorInterceptor);
}
export { isNetworkErrorMessage, isOnline, logError, logErrorWithOnlineCheck, request };
